import styled from '@emotion/styled';
import { TextField } from 'formik-mui';
import { FieldArray, useFormikContext, Field } from 'formik';
import { Grid, Button, IconButton } from '@mui/material';
import DragIndicatorRoundedIcon from '@mui/icons-material/DragIndicatorRounded';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import RemoveCircleOutlineRoundedIcon from '@mui/icons-material/RemoveCircleOutlineRounded';
import { useQuery } from '@tanstack/react-query';
import { getStations } from '../apiService';
import AutoCompleteSolo from '../../../utils/FormikFields/AutoCompleteSolo';
import { useState } from 'react';

import ErrorMessage from '../../../utils/MuiFields/ErrorMessage';

import EditStation from '../Stations/EditStation';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-top: 1rem;
`;

const Stage = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  border: 1px solid ${props => props.theme.colors.border};
  padding: 1rem;
  border-radius: 3px;
  background-color: ${props => props.theme.colors.darkBg};
  margin-top: 2rem;
  cursor: move;
  transition: all 0.2s ease;
  
  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  
  &.dragging {
    opacity: 0.5;
    transform: rotate(2deg);
  }
  
  &.drag-over {
    border-color: ${props => props.theme.colors.primary};
    transform: translateY(-2px);
  }
`;

const DragHandle = styled(DragIndicatorRoundedIcon)`
  /* color: ${props => props.theme.colors.text || '#666'}; */
  cursor: grab;
  
  &:active {
    cursor: grabbing;
  }
`;

const Stages = () => {
  const { values, setFieldValue, errors } = useFormikContext() || {};
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [dragOverIndex, setDragOverIndex] = useState(null);

  const { data: stations, isLoading } = useQuery({
    queryKey: ['services/stations'],
    queryFn: getStations,
  });

  console.log(stations, "stations");  

  const handleDragStart = (e, index) => {
    setDraggedIndex(index);
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/html', e.target.outerHTML);
    e.target.classList.add('dragging');
  };

  const handleDragEnd = (e) => {
    e.target.classList.remove('dragging');
    setDraggedIndex(null);
    setDragOverIndex(null);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const handleDragEnter = (e, index) => {
    e.preventDefault();
    setDragOverIndex(index);
  };

  const handleDragLeave = (e) => {
    // Only clear drag over if we're leaving the stage entirely
    if (!e.currentTarget.contains(e.relatedTarget)) {
      setDragOverIndex(null);
    }
  };

  const handleDrop = (e, dropIndex) => {
    e.preventDefault();
    setDragOverIndex(null);
    
    if (draggedIndex === null || draggedIndex === dropIndex) return;

    const newStages = [...values.prep_stages];
    const draggedItem = newStages[draggedIndex];
    
    // Remove the dragged item
    newStages.splice(draggedIndex, 1);
    
    // Insert at new position
    newStages.splice(dropIndex, 0, draggedItem);
    
    // Update formik values
    setFieldValue('prep_stages', newStages);
  };

  return (
    <Grid size={12}>
      <Container>
        <FieldArray name="prep_stages">
          {({ insert, remove, push }) => (
            <div>
              <Button 
                startIcon={<AddCircleRoundedIcon />} 
                variant="outlined" 
                onClick={() => {
                  let rand = Math.floor(Math.random() * 1000);
                  push({ key: rand, name: '', description: '' })
                }} 
              >
                Add Stage
              </Button>
              {values?.prep_stages?.map((stage, index) => (
                <Stage
                  key={`${stage.name ||stage.key}`} // Using index as key since we're reordering
                  draggable
                  onDragStart={(e) => handleDragStart(e, index)}
                  onDragEnd={handleDragEnd}
                  onDragOver={handleDragOver}
                  onDragEnter={(e) => handleDragEnter(e, index)}
                  onDragLeave={handleDragLeave}
                  onDrop={(e) => handleDrop(e, index)}
                  className={dragOverIndex === index ? 'drag-over' : ''}
                >
                  <DragHandle />
                  <AutoCompleteSolo 
                    fieldName="name" 
                    name={`prep_stages.${index}.name`} 
                    label="Station" 
                    size='small' 
                    serverOptions={stations} 
                    fullWidth 
                    style={{ backgroundColor: '#fff' }}
                    FormComponent={<EditStation dialog={true} />} 
                  />
                  <Field 
                    component={TextField} 
                    label="Description" 
                    size='small' 
                    name={`prep_stages.${index}.description`} 
                    fullWidth 
                    style={{ backgroundColor: '#fff' }}  
                  />
                  <IconButton onClick={() => remove(index)}>
                    <RemoveCircleOutlineRoundedIcon color="error" />
                  </IconButton>
                </Stage>
              ))}
            </div>
          )}
        </FieldArray>
        {console.log(errors, "errors")}
        {errors.prep_stages && typeof errors?.prep_stages === "string" &&<ErrorMessage error message={errors.prep_stages}></ErrorMessage>}
      </Container>
    </Grid>
  );
};

export default Stages;